/* eslint-disable react/jsx-boolean-value */
/* eslint-disable react/function-component-definition */
/* eslint-disable react/jsx-no-undef */
/* eslint-disable prettier/prettier */
/* eslint-disable no-unused-vars */
/* eslint-disable arrow-body-style */
import { Box, Button, Checkbox, CircularProgress, Fade, FormControlLabel, Modal, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { useState } from "react";

const BoxWrapperStyle = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  backgroundColor: theme.palette.background.default,
  padding: "40px 40px 38px",
  borderRadius: "15px",
  "@media screen and (max-width: 600px)": {
    width: "90%",
    padding: "32px 25px 33px",
  },
  "& h3": {
    fontSize: "25px",
    color: theme.palette.text.primary,
    fontWeight: 600,
    marginBottom: "15px",
    lineHeight: "28px",
  },
  "& p": {
    color: theme.palette.text.primary,
  },
  "& .CheckBoxWrapper": {
    marginTop: "15px",
    marginBottom: "15px",
    "& .checkboxLabel": {
      color: theme.palette.text.primary,
      fontWeight: 500,
    },
  },
  "& .BtnWrapper": {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "12px",
    "& button": {
      textTransform: "none",
      backgroundColor: theme.palette.primary.main,
      color: "#ffffff",
      borderRadius: "5px",
      boxShadow: "none",
      padding: "7px 22px",
      whiteSpace: "nowrap",
      width: "100%",
      border: `2px solid ${theme.palette.primary.main}`,
      "&:focus": {
        outline: "none",
      },
      "&:hover": {
        color: theme.palette.primary.main,
        backgroundColor: "transparent",
      },
      "&.Mui-disabled": {
        opacity: "0.3",
      },
      "&.OutlineBtn": {
        color: theme.palette.primary.main,
        backgroundColor: "transparent",
        "&:hover": {
          backgroundColor: theme.palette.primary.dark,
          color: "#fff",
        },
      },
    },
  },
}));

const Popup = ({ handleDeleteSubmit, propsdata, open, setOpen, ownerId, loader }) => {
  const [checkboxes, setCheckboxes] = useState({
    siteAudit: false,
    crawlHistory: false,
    rankTracker: false,
    disavowedLinks: false,
  });

  // Handle checkbox change
  const handleCheckboxChange = event => {
    setCheckboxes({ ...checkboxes, [event.target.name]: event.target.checked });
  };

  // Check if all checkboxes are checked
  const allChecked = Object.values(checkboxes).every(Boolean);

  const handleCancel = () => {
    setOpen(false);
  };

  const handleDelete = () => {
    if (allChecked) {
      handleDeleteSubmit({ id: ownerId });
    }
  };

  return (
    <Modal open={open} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
      <Fade in={open}>
        <BoxWrapperStyle>
          <Typography component="h3"> Delete {propsdata.projectName} project?</Typography>
          <Typography component="p">Confirm that you agree to lose the following data for {propsdata.projectName} by checking these boxes:</Typography>
          <Box className="CheckBoxWrapper">
            <FormControlLabel
              control={<Checkbox name="siteAudit" checked={checkboxes.siteAudit} onChange={handleCheckboxChange} />}
              label={<span className="checkboxLabel">Site Audit: Crawl History</span>}
            />
            <FormControlLabel
              control={<Checkbox name="crawlHistory" checked={checkboxes.crawlHistory} onChange={handleCheckboxChange} />}
              label={<span className="checkboxLabel">Site Audit: Published And Draft Patches</span>}
            />
            <FormControlLabel
              control={<Checkbox name="rankTracker" checked={checkboxes.rankTracker} onChange={handleCheckboxChange} />}
              label={<span className="checkboxLabel">Rank Tracker: Keywords And Position History</span>}
            />
            <FormControlLabel
              control={<Checkbox name="disavowedLinks" checked={checkboxes.disavowedLinks} onChange={handleCheckboxChange} />}
              label={<span className="checkboxLabel">Site Explorer: Disavowed Links</span>}
            />
          </Box>
          <Box className="BtnWrapper">
            <Button onClick={handleDelete} disabled={!allChecked || loader}>
              {loader ? <CircularProgress sx={{ color: "ffff" }} /> : "Delete"}
            </Button>
            <Button onClick={handleCancel} className="OutlineBtn">
              Cancel
            </Button>
          </Box>
        </BoxWrapperStyle>
      </Fade>
    </Modal>
  );
};

export default Popup;
